var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "info-icon_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#info-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#81899B",
    d: "M7.997 11.2a.587.587 0 0 0 .428-.172.576.576 0 0 0 .175-.428V7.8a.582.582 0 0 0-.171-.428.575.575 0 0 0-.425-.172.587.587 0 0 0-.429.172.576.576 0 0 0-.175.428v2.8c0 .17.057.313.172.428a.575.575 0 0 0 .425.172Zm0-5.2a.589.589 0 0 0 .603-.597.589.589 0 0 0-.596-.603.589.589 0 0 0-.604.596.589.589 0 0 0 .597.604Zm.008 8.4a6.25 6.25 0 0 1-2.488-.5 6.453 6.453 0 0 1-2.042-1.375A6.454 6.454 0 0 1 2.1 10.484a6.255 6.255 0 0 1-.5-2.492 6.2 6.2 0 0 1 .5-2.484A6.453 6.453 0 0 1 5.516 2.1a6.255 6.255 0 0 1 2.492-.5 6.2 6.2 0 0 1 2.484.5A6.477 6.477 0 0 1 13.9 5.512c.333.775.5 1.603.5 2.483 0 .881-.167 1.71-.5 2.488a6.451 6.451 0 0 1-3.412 3.417c-.775.333-1.602.5-2.483.5ZM8 13.2c1.445 0 2.672-.506 3.683-1.517C12.694 10.673 13.2 9.444 13.2 8s-.505-2.672-1.517-3.683C10.673 3.306 9.445 2.8 8 2.8c-1.444 0-2.672.506-3.683 1.517C3.306 5.327 2.8 6.556 2.8 8s.506 2.672 1.517 3.683C5.327 12.694 6.556 13.2 8 13.2Z"
  }))));
};
export default SvgInfoIcon;